import React from 'react';

import Likes from '../../containers/metadata/likes';
import Downloads from '../../containers/metadata/downloads';
import Miscellaneous from '../../containers/metadata/miscellaneous';
import RelatedItems from '../../containers/metadata/relateditems';
import Togglable from '../togglable';

const Sidebar = Togglable(() => (
	<div className="col-lg-3">
		<h2 className="text-black-secondary typography-body-2">Video info</h2>
		<div className="align-items-center d-flex mb-3 mb-lg-4">
			<div className="flex-fill">
				<Likes />
			</div>
			<div className="flex-shrink-0">
				<Downloads />
			</div>
		</div>

		<Miscellaneous />

		<RelatedItems />
	</div>
))

export default Sidebar